import React from "react";
import { useTranslation } from "next-i18next";

function DifficultyImage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18" fill="none">
      <path d="M0.307952 17.4104C0.201751 17.3339 0.0955493 16.0938 0.446951 15.8127C1.02481 15.3504 7.20324 15.1943 7.54215 15.7737C7.82952 16.2656 7.79984 17.3401 7.61868 17.3526C7.43751 17.3651 0.414154 17.4885 0.307952 17.4104Z" fill="white" />
      <path d="M0.13929 0.871138C0.368873 0.560342 2.94582 0.465073 4.47169 0.679038C5.81795 0.869576 6.88621 1.19443 7.00178 3.86821C7.13141 6.83873 5.88354 7.15265 3.68923 7.32444C6.29898 7.24323 7.88107 8.21466 7.98571 10.1013C8.11377 12.4299 7.41409 13.5247 4.54665 13.6138C4.54665 13.6138 0.826477 13.848 0.387615 13.3529C-0.051247 12.8579 -0.0918544 1.18037 0.137728 0.871138H0.13929ZM1.86194 5.95632C1.88849 6.16403 3.9766 6.32646 4.74031 5.59711C5.12608 5.22852 5.43531 4.04 4.99645 2.953C4.45138 1.60518 2.01031 2.05653 1.90099 2.38607C1.65422 3.12636 1.78385 5.34566 1.86194 5.95632ZM2.11339 11.8349C2.51321 12.1738 3.49557 12.1347 4.80747 11.8786C6.78938 11.4929 6.31928 9.27043 4.6591 8.92215C2.54132 8.4786 1.89005 8.75972 1.87756 9.21733C1.86663 9.58747 1.88068 11.6365 2.11339 11.8349Z" fill="white" />
    </svg>
  );
}

export default function RecipeDifficultyTag({ difficulty }) {
  let difficultyLevel = 0;
	const { t } = useTranslation();

  switch (difficulty) {
    case "facile":
      difficultyLevel = 1;
      break;
    case "moyen":
      difficultyLevel = 2;
      break;
    case "difficile":
      difficultyLevel = 3;
      break;
  }

  return (
    <div className="difficulty_tag_container">
      <div className="difficulty_tag">
        <p>{t("filter.difficulty")} :</p>
        {Array.from({ length: difficultyLevel }).map((_, index) => (
          <DifficultyImage key={index} />
        ))}
      </div>
    </div>
  );
}
